import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['specifications', 'specification', 'name', 'size', 'weight', 'tags', 'tag', 'tagTemplate', 'kbn'];

  connect() {
    this.specificationTargets.forEach((target) => {
      if (target.querySelector('input').checked) {
        this.createTag(target.dataset.name, target.dataset.value);
      }
    });
  }

  sort({ params: { sortBy } }) {
    if (!['name', 'size', 'weight'].includes(sortBy)) {
      return;
    }

    const sortTargets = this.specificationTargets;
    let sortDirection;
    if (this.specificationsTarget.dataset.sortedBy === sortBy
      && this.specificationsTarget.dataset.sortDirection === 'asc') {
      sortDirection = 'desc';
    } else {
      sortDirection = 'asc';
    }

    sortTargets.sort((targetA, targetB) => {
      const weightA = targetA.dataset[sortBy];
      const weightB = targetB.dataset[sortBy];

      if (weightA === weightB) {
        return 0;
      } if (weightA > weightB) {
        return (sortDirection === 'asc' ? 1 : -1);
      }
      return (sortDirection === 'asc' ? -1 : 1);
    });

    this.specificationsTarget.inner_html = '';
    sortTargets.forEach((e) => { this.specificationsTarget.appendChild(e); });
    this.specificationsTarget.dataset.sortedBy = sortBy;
    this.specificationsTarget.dataset.sortDirection = sortDirection;
  }

  checkHandler(e) {
    const { name } = e.params;
    const { value } = e.params;

    if (e.currentTarget.checked) {
      this.createTag(name, value);
    } else {
      this.removeTag(value.toString());
    }
  }

  createTag(name, value) {
    const newTag = this.tagTemplateTarget.cloneNode(true);
    newTag.querySelector('.label').innerHTML = name;
    newTag.dataset.value = value;
    newTag.classList.remove('hidden');
    this.tagsTarget.appendChild(newTag);
  }

  removeTag(value) {
    this.tagTargets.forEach((target) => {
      if (target.dataset.value === value) {
        target.remove();
      }
    });
  }

  closeTagHandler(e) {
    const { element } = e.detail;
    this.specificationTargets.forEach((target) => {
      if (target.dataset.value === element.dataset.value) {
        target.querySelector('input').checked = false; // eslint-disable-line no-param-reassign
      }
    });
    element.remove();
  }

  changeKbnHandler() {
    if (this.kbnTarget.value) {
      this.specificationTargets.forEach((target) => {
        if (target.dataset.kbn === this.kbnTarget.value) {
          target.classList.remove('hidden');
        } else {
          target.classList.add('hidden');
        }
      });
    } else {
      this.specificationTargets.forEach((target) => {
        target.classList.remove('hidden');
      });
    }
  }
}
